import React from 'react';
import styles from './FilterChip.css';

const FilterChip = ({ label, value, campname, id, flexValue, paddingLeft,
  leadTypeData, marginRight, marginRightIpad }) => {
  /* Added becuase the virtual table has a margin of 10px
    Added Margin Left only if Manage App and for the first filter value.
    In case of Assign there is an empty space which adds the required Margin Left
  */
  let chipValue = value;
  let marginRightProp = marginRight;
  const isIpad = window.innerWidth <= 768;
  if (isIpad) {
    marginRightProp = marginRightIpad;
  }

  if (label === 'Campaign') {
    if (id > 1) {
      chipValue += id - 1;
    }
  } else if (leadTypeData && leadTypeData.indexOf('Campaign') > -1) {
    chipValue += id;
  }
  return (
    <div
      style={(__MANAGE__) ?
        { flex: flexValue, marginRight: '10px', paddingLeft: `${paddingLeft}px` } :
        { flex: flexValue, marginRight: (marginRight === undefined) ? '10px' : `${marginRightProp}px` }
      }
    >
      { chipValue > -1 &&
        <div className={chipValue > 1 ? styles.chipViewActive : styles.chipView}>
          <div className={chipValue === 0 ? styles.chipInactive : styles.chipActive}>
            <span>
              {label === 'Campaign' && campname ? `${campname}` : label}
            </span>
          </div>
          <span className={styles.chipCount}>{chipValue > 1 && ` +${chipValue - 1}`}</span>
        </div>
      }
    </div>
  );
};

FilterChip.propTypes = {
  label: React.PropTypes.string,
  value: React.PropTypes.number,
  flexValue: React.PropTypes.string,
  paddingLeft: React.PropTypes.number,
  id: React.PropTypes.number,
  campname: React.PropTypes.string,
  leadTypeData: React.PropTypes.arrayOf(React.PropTypes.string),
  marginRight: React.PropTypes.number,
  marginRightIpad: React.PropTypes.number
};

export default FilterChip;



// WEBPACK FOOTER //
// ./src/components/FilterChip/FilterChip.js